import { ViteReactSSG } from "vite-react-ssg";
import { HelmetProvider } from "react-helmet-async";
import { routes } from "./App";

// Self-hosted fonts — Latin subset only (Italian site), only weights actually used
import "@fontsource/inter/latin-300.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "@fontsource/playfair-display/latin-400.css";
import "@fontsource/playfair-display/latin-600.css";
import "@fontsource/playfair-display/latin-700.css";

import "./index.css";

export const createRoot = ViteReactSSG(
  { routes },
  ({ isClient, initialState }) => {
    // no-op
  },
  {
    rootContainer: "#root",
    transformState(state) {
      return state;
    },
  },
);
